import { SalesDetailsSection } from 'src/modals/ListingDetails/ListingForms/SalesForm/SalesDetailsSection';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ListingDetails,
  PointOfSaleSaleStatus,
  Ticket,
} from 'src/WebApiController';

type ListingDetailsSalesFormProps = {
  listing?: ListingDetails | null;
};

export const ListingDetailsSalesForm: React.FC<
  ListingDetailsSalesFormProps
> = ({ listing }) => {
  const { tickets = [] } = listing ?? {};
  const ticketsWithSales = tickets?.filter((ticket) => ticket.id);

  const ticketsBySalesId = ticketsWithSales?.reduce<Record<string, Ticket[]>>(
    (acc, curr) => {
      if (!curr.id) return acc;
      const sale = acc[curr.id] ?? [];
      return { ...acc, [curr.id]: [...sale, curr] };
    },
    {}
  );

  const wastedSales = listing?.saleInfos?.filter(
    (saleInfo) => saleInfo.stat === PointOfSaleSaleStatus.Wasted
  );

  const nonWastedSales = listing?.saleInfos?.filter(
    (saleInfo) => saleInfo.stat !== PointOfSaleSaleStatus.Wasted
  );

  return (
    <>
      <SalesDetailsSection
        ticketsBySalesId={ticketsBySalesId}
        sectionName={ContentId.Sales}
        seating={listing?.seating}
        saleInfos={nonWastedSales}
      />
      <SalesDetailsSection
        ticketsBySalesId={ticketsBySalesId}
        sectionName={ContentId.Wasted}
        seating={listing?.seating}
        saleInfos={wastedSales}
      />
    </>
  );
};
